import React from 'react'
import MuiTable from '../../../Forms/SharedComponents/containers/MuiTable'
import { TABLA_MERCADERIA_SECADA_DOS_MAS } from '../../../../config/tables'

function LiquidacionMercaderiaSecadaDosMasView () {
  return (
    <MuiTable id={TABLA_MERCADERIA_SECADA_DOS_MAS} />
  )
}

export default LiquidacionMercaderiaSecadaDosMasView
